export const constant = {
	selector: {
		handler: 'js-submitter-handler',
	},
}
